import {ReactElement} from 'react'
import {Trans} from 'react-i18next'

import {Currency} from '../../../../../graphql/types'
import {getFormattedAmount} from '../../../../../common/utils'
import messages from '../../../../../assets/messages'
import {useStyles} from './styles'

type MinimumDepositRequiredProps = {
  minimumDepositAmount: number,
  currency: Currency | undefined,
}

function MinimumDepositRequired(props: MinimumDepositRequiredProps): ReactElement {
  const {minimumDepositAmount, currency} = props
  const classes = useStyles()

  const isDepositAboveZero = minimumDepositAmount > 0

  return (
    <>
      <div className={classes.container}>
        {isDepositAboveZero ? (
          <Trans
            {...messages.minimumDepositAmountRequiredTile}
            values={{amount: getFormattedAmount({currency: currency, amount: minimumDepositAmount})}}
          />
        ) : (
          <Trans {...messages.minimumDepositRequiredTile} />
        )}
      </div>
      <div className={classes.heightOverlay}></div>
    </>
  )
}

export {MinimumDepositRequired}
